import styled, { css } from 'styled-components';

export const Svg = styled.svg`
  width: 35px;
  margin: 0 18px;
  ${(props) =>
    props.filled &&
    css`
      fill: #fa7814;
    `};
`;
